


























import { defineComponent } from "@vue/composition-api";
import { useLang, Translate } from "@lang";
import { AbsBox, Container, Icon } from "@ui";

export default defineComponent({
	components:{
		AbsBox,
		Container,
		Icon,
		Translate,
	},
	setup(_, context){

		const { translate } = useLang(context);

		return {
			translate
		};
	}
});
